export const GROUPS_VIEW_PREFERENCE_KEY = "groups:view:preference";

export const GROUPS_VIEW = {
  LEGACY: "legacy",
  NEW: "new",
} as const;

export type GroupsViewPreference =
  (typeof GROUPS_VIEW)[keyof typeof GROUPS_VIEW];

const DEFAULT_GROUPS_VIEW: GroupsViewPreference = GROUPS_VIEW.NEW;

export const getGroupsViewPreference = (
  isSuperUser = true,
): GroupsViewPreference => {
  const preference = localStorage.getItem(GROUPS_VIEW_PREFERENCE_KEY);

  if (preference === GROUPS_VIEW.LEGACY || preference === GROUPS_VIEW.NEW) {
    return preference;
  }

  return isSuperUser ? DEFAULT_GROUPS_VIEW : GROUPS_VIEW.LEGACY;
};

export const setGroupsViewPreference = (value: GroupsViewPreference): void => {
  localStorage.setItem(GROUPS_VIEW_PREFERENCE_KEY, value);
};

export const getGroupsViewPath = (
  value?: GroupsViewPreference,
  isSuperUser = true,
): string => {
  const preference = value ?? getGroupsViewPreference(isSuperUser);

  return preference === GROUPS_VIEW.LEGACY
    ? "/admin/accessControlGroups-legacy"
    : "/admin/accessControlGroups";
};
